export enum PriceRangeChange {
  RaisedRange = 'Raised Range',
  LoweredRange = 'Lowered Range',
  NoChange = 'No Change',
}
